import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { DrawerProps } from 'components/Drawer/Root'
import { Provider } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'

export interface SelectMediaProps {
  file: IMediaFile
  needsDownload: boolean
  provider?: Provider
}

interface AcceptMediaProps {
  accept: string
}

export interface UploadedMediaCarouselProps extends AcceptMediaProps {}

export interface UploadImageButtonProps extends AcceptMediaProps {}

export interface ChooseMediaProps extends AcceptMediaProps {
  altButton?: React.ReactNode
}

export enum ProcessingState {
  Downloading = 'downloading',
  Uploading = 'uploading',
  RemovingBackground = 'removingBg',
  Complete = 'complete',
}

export interface ProcessingFile {
  file: IMediaFile
  processingState?: ProcessingState
}

export interface ProcessingMediaProps {
  selectedMedia: IMediaFile
  processingState?: ProcessingState
}

export interface MediaDrawerProps extends DrawerProps {
  title: string
}

export interface SelectMediaDrawerProps extends MediaDrawerProps {
  onSelect: (props: SelectMediaProps) => void
}

export interface MediaPickerProviderProps {
  onSelect: (file: IMediaFile, removeBackground: boolean, provider?: Provider) => void
  selectedFiles?: Array<IMediaFile>
  skipBackgroundRemoval?: boolean
}

export interface MediaPickerProps {
  accept: string
  altButton?: React.ReactNode
  multiSelect?: boolean
}

export interface MediaPickerContainerProps extends MediaPickerProviderProps, MediaPickerProps {}
